//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
export default {
    data() {
        return {
            host: '',
            token: '',
            urgentTel: ''
        }
    },
    computed:{
        ...mapGetters('user',{
            user:'getUser'
        })
    },
    created() {
        this.host = window.location.origin;
        this.token = sessionStorage.getItem('access_token');
    }
}



// WEBPACK FOOTER //
// ./src/pages/code/view.vue